/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Lightning = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Lightning"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F50"
      fillRule="evenodd"
      d="M12.836 2.238a1.6 1.6 0 0 0-2.23.571l-4.874 8.334a1.7 1.7 0 0 0-.021 1.678c.288.523.829.846 1.414.846h6.88l-3.398 5.809c-.462.789-.213 1.813.557 2.286s1.768.218 2.23-.571l4.874-8.333c.302-.515.31-1.157.021-1.68a1.62 1.62 0 0 0-1.414-.845h-6.88l3.398-5.809c.462-.789.213-1.813-.557-2.286"
      className="SVG"
      clipRule="evenodd"
    />
  </svg>
);

export const LightningIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'lightning-icon'}
      icon={Lightning}
      {...props}
      size={size}
    />
  );
};
